import { green, grey } from '@material-ui/core/colors';
import { createMuiTheme, Theme as MUITheme } from '@material-ui/core';
import personalAgreementBg from '../static/images/skoda.png';
import { BrandsEnum } from '../surveyCollector/SurveyCollector';

const mainColor = '#4ba82e';

const { spacing } = createMuiTheme();

const myGreen = {
  ...green,
  '500': mainColor,
  '600': mainColor,
  A100: mainColor,
  A200: mainColor,
  A400: mainColor,
  A700: mainColor,
};

const fontFamily =
  '"SKODA Next", "Helvetica Neue", Helvetica, Arial, sans-serif';

const theme = {
  palette: {
    primary: myGreen,
    secondary: {
      light: grey.A100,
      main: grey.A200,
      dark: grey.A400,
      contrastText: '#ffffff',
    },
    background: {
      default: 'ffffff',
    },
  },
  typography: {
    fontFamily: fontFamily,
    useNextVariants: true,
  },
  screenElement: {
    sidePadding: spacing(3),
    sidePaddingXs: spacing(),
  },
  images: {
    introDefaultImagePath: 'images/ProduktCX/introCar.png',
    progressImagePath: 'images/ProduktCX/car.png',
    logo: 'images/ProduktCX/logo.png',
    favicon: 'favicons/skoda.png',
  },
  personalAgreement: {
    backgroundImagePath: personalAgreementBg,
    continueButtonColor: '#3b9cdf',
  },
  title: 'Produkt CX',
  brandCode: BrandsEnum.NEVQS,
};

export type Theme = typeof theme & MUITheme;

export default theme;
